module.exports = __webpack_public_path__ + "static/img/rank_bg_red.d47708ef.png";